<template>
  <v-row class="ma-0 h-100 overflow-overlay">
    <v-col :sm="viewerOpened ? 8 : 12" v-if="!isViewerFullscreen" class="pa-0 overflow-y-auto h-100">
      <v-sheet class="pe-2 d-flex flex-column h-100">
        <v-slide-y-transition>
          <div class="d-flex" v-if="showCharts">
            <v-row class="ma-3">
              <!-- <v-col cols="12" class="px-0 pb-0">
                <v-card-title class="font-weight-bold pa-0 text-h6"> Heat Exchanger </v-card-title>
              </v-col> -->
              <v-col cols="4" class="ps-0 pb-0">
                <temprature-chart
                  :canvasHeight="'270px'"
                  :title="'Temperature'"
                  :chartData="tempratureChartData"></temprature-chart>
              </v-col>
              <v-col cols="4" class="pe-0 pb-0">
                <flow-chart
                  :canvasHeight="'270px'"
                  :title="'Flow (m³/h)'"
                  :chartData="flowChartData"></flow-chart>
              </v-col>
              <v-col cols="4" class="pe-0 pb-0">
                <gauge-chart
                  :canvasHeight="'270px'"
                  :title="'Pressure'"
                  :indicator1="'-100'"
                  :indicator2="'-50'"
                  :indicator3="'0'"
                  :indicator4="'50'"
                  :indicator5="'100'"
                  :mainValue="mainValue"
                  :needleValue="needleValue"></gauge-chart>
              </v-col>
            </v-row>
          </div>
        </v-slide-y-transition>

        <div class="mx-3 flex-grow-1">
          <dashboard-grid
            ref="dashboardGrid"
            class="flex-grow-1"
            :viewerOpened="viewerOpened"
            gridName="inspection"
            @openViewer="openViewer"
            @tagSelected="handleTagSelected"
            :selectedFilters="selectedFilters" 
            :selectedRowsData.sync="selectedRowsData"
            :coloredInspections.sync="coloredInspections"></dashboard-grid>
        </div>
      </v-sheet>
    </v-col>
    <v-col
      :cols="isViewerFullscreen ? '12' : '4'"
      v-show="viewerOpened"
      class="pb-0 h-100 overflow-overlay"
      :class="{ absoluteViewer: isViewerFullscreen }">
      <viewers-section
        ref="viewersSection"
        :hide360View="true"
        :viewerTab.sync="viewerTab"
        @closeViewersSection="closeInspectViewer"
        @toggleFullscreen="toggleFullscreen">
      </viewers-section>
    </v-col>
  </v-row>
</template>
<script>
  import { ForgeInspection } from '@/scripts/js/forgeModels';
  import DashboardGrid from '../components/DashboardGrid.vue';

  import ViewersSection from '../components/ViewersSection.vue';
  import TempratureChart from '../components/line-chart/temprature-chart.vue';
  import FlowChart from '../components/bar-chart/flow-chart.vue';
  import GaugeChart from '../components/doughnut-chart/gauge-chart.vue';
  import { log, warn, error } from '@/utils/debugLogger';

  export default {
    name: 'IOWsDashboard',
    data() {
      return {
        viewerTab: '3D View',
        isViewerFullscreen: false,
        needleValue: 0,
        mainValue: 0,
        flowChartData: [0, 0, 0, 0, 0, 0, 0, 0],
        tempratureChartData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        showCharts: false,
      };
    },
    components: {
      DashboardGrid,
      ViewersSection,
      TempratureChart,
      FlowChart,
      GaugeChart,
    },
    computed: {
      selectedFilters() {
        return {}
      },
      viewerOpened: {
        get() {
          return this.$store.getters['IOW_DASHBOARD/GET_VIEWER_OPENED'];
        },
        set(value) {
          this.$store.commit('IOW_DASHBOARD/SET_VIEWER_OPENED', value);
        },
      },
      coloredInspections: {
        get() {
          return this.$store.getters['IOW_DASHBOARD/GET_COLORED_INSPECTIONS'];
        },
        set(value) {
          this.$store.commit('IOW_DASHBOARD/SET_COLORED_INSPECTIONS', value);
        },
      },
      selectedRowsData: {
        get() {
          return this.$store.getters['IOW_DASHBOARD/GET_SELECTED_ROWS_DATA'];
        },
        set(value) {
          this.$store.commit('IOW_DASHBOARD/SET_SELECTED_ROWS_DATA', value);
        },
      },
      forgeService: {
        get() {
          return this.$store.state.forgeService;
        },
      },
      viewer() {
        return this.$store.state.viewer;
      },
      isAMIS() {
        return !!this.$store.state.forgeSettings?.isAMIS;
      },
    },
    activated() {
      if (this.viewerOpened) {
        this.openViewer();
      }
    },
    mounted() {
      // this.forgeService.loadInspectionTagsAdvanced('', false);
      this.startRandomNumberGenerator();
      this.startUpdatingChartData();
    },
    methods: {
      closeInspectViewer() {
        this.viewerOpened = false;
      },
      openViewer() {
        this.viewerOpened = true;
        this.handleViewerChange();
      },
      handleTagSelected() {
        this.showCharts = true;
        this.startRandomNumberGenerator();
        this.startUpdatingChartData();
      },
      handleViewerChange() {
        if (this.viewerTab === '3D View') {
          this.handle3dViewer();
        } else if (this.viewerTab === '2D View') {
          this.handle2dViewer();
        }
      },
      handle3dViewer() {
        this.$refs.viewersSection.load3dViewer().then(() => {
          this.$refs.dashboardGrid.isolateSelectedInspection3d();
        });
      },
      handle2dViewer() {
        if (!this.viewerOpened) return;
        
        let selectedInspections = this.$refs.dashboardGrid.selectedColoredInspections;

        if (!Array.isArray(selectedInspections)) selectedInspections = [selectedInspections];

        if (selectedInspections.length === 0) {
          this.$dialog.notify.error('No inspection selected');
          return;
        }

        selectedInspections = selectedInspections.map((o) => {
          if (o instanceof ForgeInspection) {
            return o;
          } else {
            let e = Object.assign(new ForgeInspection(), o);
            e.parseContent();
            return e;
          }
        });

        this.handleIsolateMatchedInspections2d(selectedInspections);
      },
      async handleIsolateMatchedInspections2d(inspections) {
        let points = inspections.map((o) => o?.point).filter((o) => o);

        let levelsSet = new Set(points.map((o) => this.forgeService.getLevelContainsPoint(o)));

        let levels = Array.from(levelsSet).filter((o) => o);

        let level = levels.length == 1 ? levels[0] : this.$store.state.levels[0];

        if (levels.length > 1) {
          error('IOWs', 'Multiple levels found', levels);
          this.$dialog.notify.warning('Multiple levels found');
        }

        this.$store.state.selectedLevel = level;

        if (!level?.planUrn) {
          error('IOWs', 'Plan URN not found', level);
          this.$dialog.notify.error('Plan URN not found');
          this.$refs.viewersSection.viewerState.isLoading = false;
          return;
        }

        this.$refs.viewersSection.load2dViewer(level.planUrn).then(() => {
          // this.forgeService.zoomToPoints2D(points);
          this.forgeService.getLabels2DExtension().clear3DTags();
          this.forgeService.getLabels2DExtension().createHighlightingTags(inspections);
          this.$refs.viewersSection.viewerState.isLoading = false;
        });
      },
      toggleFullscreen(event) {
        this.isViewerFullscreen = event;
        this.$store.commit('SET_VIEW_1_TYPE', '3d');
        this.$store.commit('SET_IS_VIEW_1_VISIBLE', true);
        this.$store.commit('SET_IS_VIEW_2_VISIBLE', false);
        this.$store.commit('SET_IS_VIEW_3_VISIBLE', false);
        this.$store.commit('SET_IS_VIEW_4_VISIBLE', false);
        this.$router.push({
          name: 'facility',
          query: {},
        });
      },
      startRandomNumberGenerator() {
        // setInterval(() => {
        //   this.needleValue = Math.floor(Math.random() * (85 - 60 + 1) + 60);
        // }, 150); // 0.5 seconds
        this.needleValue = Math.floor(Math.random() * (80 - 75 + 1) + 75);
        this.mainValue = Math.floor(Math.random() * (60 - 50 + 1) + 50);
      },
      startUpdatingChartData() {
        // setInterval(() => {
        //   this.flowChartData = this.flowChartData.map(() =>
        //     Math.floor(Math.random() * (800 - 200 + 1) + 200),
        //   );
        // }, 1000);
        this.flowChartData = this.flowChartData.map(() =>
          Math.floor(Math.random() * (750 - 650 + 1) + 650),
        );

        // setInterval(() => {
        //   this.tempratureChartData = this.tempratureChartData.map(() =>
        //     Math.floor(Math.random() * (60 - 50 + 1) + 50),
        //   );
        // }, 1000);
        this.tempratureChartData = this.tempratureChartData.map(() =>
          Math.floor(Math.random() * (60 - 50 + 1) + 50),
        );
      },
    },
    watch: {
      viewerOpened() {
        this.$emit('viewerOpened', this.viewerOpened);
      },
      viewerTab: {
        handler: function () {
          this.handleViewerChange();
        },
      },
    },
  };
</script>
<style lang="scss">
  .customSearchBox {
    .v-input__control .v-input__slot {
      padding-right: 5px;
      .v-input__append-inner {
        margin-top: 5px !important;
        .v-input__icon--append {
          border-radius: 50%;
          background-color: var(--v-primary-base);
          width: 30px;
          height: 30px;
          i {
            color: var(--v-white-base);
          }
        }
      }
    }
  }

  .activeTab {
    border: 1px solid var(--v-primary-base);
    background-color: var(--v-white-base) !important;
  }

  .custom-tabs {
    .v-tab {
      color: var(--v-primary-base) !important;
    }
    .v-tab--active {
      color: inherit;
    }
  }
  .customBoxShadow {
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
      0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  }
  .v-list-item::not {
    border-bottom: 1px solid var(--v-grey-500-lighten4);
  }
  .notSelectedChip {
    background-color: #edf2e8 !important;
    // background-color: var(--v-light-grey2-base) !important;
    // color: var(--v-primary-base) !important;
  }
  .selectedChip {
    background-color: #edf2e8 !important;
    color: var(--v-primary-base) !important;
    border: 2px solid var(--v-primary-base);
  }

  .option-input-wrapper input {
    width: 50px;
    height: 35px;
    border: none;
    padding: 0px;
    background-color: transparent;
  }
  .theme--dark .option-input-wrapper input {
    color: var(--v-bg_force_white-base);
  }

  .LastInspectionsToggle {
    & .v-btn {
      color: var(--v-primary-base) !important;
      text-transform: none !important;
      background-color: #edf2e8 !important;
      letter-spacing: normal !important;
      font-weight: 600;
      border: none;

      & i {
        color: var(--v-primary-base) !important;
      }

      &:hover:before {
        background-color: var(--v-primary-base);
      }

      &.v-btn--active {
        color: white !important;
        box-shadow: none !important;

        & i {
          color: white !important;
        }

        &:before {
          background-color: var(--v-primary-base);
          opacity: 1;
        }
      }
    }
  }

  .hasValue {
    background-color: var(--v-light_Primary-base);
  }
  .v-chip-custom {
    font-size: 11px;
    height: 27px;
    width: 27px;
    text-align: center;
    .v-chip__content {
      justify-content: center;
    }
  }
  .absoluteViewer {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
  }
  .totalCard {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05) !important;

    border-radius: 7px;
    cursor: pointer;
  }
  .RemainingLife {
    &:hover {
      background-color: #efeff5;
    }
  }
  .TMin {
    &:hover {
      background-color: #ecf1f5;
    }
  }
  .tminActive {
    &:hover {
      background-color: #ecf1f5 !important;
    }
  }
  .remainingLifeActive {
    &:hover {
      background-color: #efeff5 !important;
    }
  }

  .totalResult {
    font-size: 24px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: var(--v-grey-500-base);
  }
  .iconContainer {
    width: 54px;
    height: 54px;
    padding: 10px;
    gap: 10px;
    border-radius: 50px;
  }
</style>
